import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchInvestigationMaster } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getInvestigationlist } from "../../../redux/action/investigation_action";

const InvestigationMultipleSelectorDropdown = ({
  errors,
  control,
  setValue,
  watch,
  rowData,
  required,
}) => {
  const dispatch = useDispatch();
  const login = useSelector((state) => state.jwtAuthreducer);
  const selectedInvestigationIds = watch("investigation_id") || [];

  const { data: Investigations, refetch, isLoading, error } = useQuery(
    ["Investigation"],
    () => fetchInvestigationMaster({ payload: { ...login } }),
    {
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    refetch();
  }, [login]);

  const optionsList = useMemo(
    () =>
      Investigations?.data?.data?.map((ele) => ({
        value: ele.id,
        label: ele.investigation_name,
      })) || [],
    [Investigations]
  );

  useEffect(() => {
    if (rowData && optionsList.length) {
      const rowDataOptions = optionsList.filter((option) =>
        rowData?.investigation_obj
          ? rowData?.investigation_obj?.some(
            (investigation) => investigation.id === option.value
          )
          : rowData?.investigations?.some(
            (investigation) => investigation.investigation_id === option.value
          )
      );
      if (rowDataOptions.length) {
        const ids = rowDataOptions.map((opt) => opt.value);
        const names = rowDataOptions.map((opt) => opt.label);
        setValue("investigation_id", ids);
        setValue("investigation_name", names);
      }
    }
  }, [rowData, optionsList, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Investigation Data</div>;

  const dynamicHeight = selectedInvestigationIds.length > 5
    ? Math.min(45 + selectedInvestigationIds.length * 5, 200)
    : 45;

  return (
    <Controller
      name="investigation_id"
      control={control}
      rules={{ required: "At least one investigation is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={optionsList}
          isMulti
          isClearable
          placeholder="Select Investigation Names"
          menuPortalTarget={document.body}
          value={optionsList.filter((option) =>
            selectedInvestigationIds.includes(option.value)
          )}
          onChange={(selectedOptions) => {
            const values = selectedOptions ? selectedOptions.map((option) => option.value) : [];
            const labels = selectedOptions ? selectedOptions.map((option) => option.label) : [];
            field.onChange(values);
            setValue("investigation_id", values);
            setValue("investigation_name", labels);
            dispatch(getInvestigationlist(values));
          }}
          className={`react-select-container ${errors.investigation_id ? "is-invalid" : ""}`}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              minHeight: `${dynamicHeight}px`,
              maxHeight: "auto",
              overflowY: "auto",
            }),
            valueContainer: (base) => ({
              ...base,
              maxHeight: `${dynamicHeight}px`,
              overflowY: "auto",
            }),
            multiValue: (base) => ({
              ...base,
              maxWidth: "100%",
            }),
          }}
        />
      )}
    />
  );
};

export default InvestigationMultipleSelectorDropdown;
